import { useState, useRef, useEffect } from 'react';
import ResizeObserver from 'resize-observer-polyfill'; // TODO: see if there's a package for measuring using resize observer

var useMeasure = function useMeasure() {
  var ref = useRef();

  var _useState = useState({
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    width: 0,
    height: 0,
    x: 0,
    y: 0
  }),
      bounds = _useState[0],
      set = _useState[1];

  var _useState2 = useState(function () {
    return new ResizeObserver(function (_ref) {
      var entry = _ref[0];
      return set(entry.contentRect);
    });
  }),
      ro = _useState2[0];

  useEffect(function () {
    if (ref.current) ro.observe(ref.current);
    return function () {
      return ro.disconnect();
    };
  }, [ro]);
  return [{
    ref: ref
  }, bounds];
};

export default useMeasure;